import { FlagOutlined } from '@ant-design/icons';
import {
  Datatype,
  IWidgetType,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  getSimpleWidgetReference,
  tran,
} from '@framework/engine';
import { CompetenceWidgetComponent } from './CompetenceWidgetComponent';
import {
  CompetenceInputConfigComponent,
  CompetenceWidgetConfigSchema,
} from './CompetenceWidgetConfigComponent';
import { ICompetenceWidget, WidgetTypeCompetence } from './ICompetenceWidget';
import { createCompetenceSelectFormSchema } from './createCompetenceSelectFormSchema';
import { hydrateCompetenceWidget } from './hydrateCompetenceWidget';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Competence = 'competence',
  }
}

export const CompetenceWidgetType: IWidgetType<ICompetenceWidget> = {
  type: WidgetTypeCompetence,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Selezione Competenza',
  icon: <FlagOutlined />,
  hasValue: true,
  hydrate: hydrateCompetenceWidget,
  getReference: getSimpleWidgetReference(Datatype.String),
  getSiblingReferences: () => [],
  formComponent: CompetenceWidgetComponent,
  createFormSchema: createCompetenceSelectFormSchema,
  previewComponent: CompetenceWidgetComponent,
  configValidator: CompetenceWidgetConfigSchema,
  configComponent: CompetenceInputConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    placeholder: tran.string(),
    helpText: tran.rte(),
  }),
  rules: [RequiredRule],
};
